import React from "react";

export default function RestlessCategoryFormatter(cellContent) {
  return <div>{cellContent ? cellContent : "My Space"}</div>;
}